/**
 * What a flight's end does to the saves (04 §10; ROUND7 §5). A mission that ends deletes the suspend save - it
 * is over, and there is nothing to resume. A TRAINING flight is the exception: the title offers the course even
 * while a ranger is held in the field, so the save on disk belongs to that other mission and must survive the
 * course untouched. Training's own mark is a local flag: "finished once in this browser".
 */

import type { Deployment } from '../../meta/api';
import type { MissionResult, Outcome } from '../../sim/types';

export interface FlightPorts {
  clearSuspend(): void;
  /** Tell the cloud layer the suspend save changed. */
  touchSuspend(): void;
  /** Record that the course has been finished in this browser. */
  markTrainingDone(): void;
}

export function settleFlight(mode: Deployment['mode'], outcome: Outcome, ports: FlightPorts): void {
  if (mode === 'training') {
    if (outcome === 'extracted') ports.markTrainingDone();
    return;
  }
  ports.clearSuspend();
  ports.touchSuspend();
}

/**
 * The result the end card is handed when the range officer stops the course (see ./index.ts): nothing was
 * scored and nobody boarded. The end card reads the stop note, not this outcome.
 */
export function stoppedResult(): MissionResult {
  return { outcome: 'scrubbed', objectiveComplete: false, lines: [], multiplier: 1, total: 0, secondsLeft: 0 };
}
